import { useEffect } from "react";
import { useLoadedData } from "../../toolympus/hooks/useLoadedData";
import { useSetAutoSuggestionsOptions } from "../../toolympus/components/primitives/AutoSuggests";

export const CoPAgendaItemsSuggestionsKey = "cop_topic";

export const useCoPAgendaItemsSuggestions = () => {
  const setOptions = useSetAutoSuggestionsOptions();

  const suggestionsData = useLoadedData<string[]>(`/api/cop-decision/agenda-item-suggestions`, []);

  useEffect(() => {
    setOptions(CoPAgendaItemsSuggestionsKey, suggestionsData.data);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestionsData.data]);

  return {
    ...suggestionsData,
  }
}
